import React from 'react';
import { HEADER } from './content-types';

export const getImageSizes = (
    imageCount,
    image,
    containerType,
    isGrid,
    format = 'jpg&fl=progressive'
) => {
    if (!image) {
        return {};
    }
    const { baseUrl } = image;

    const imageUrl = baseUrl + '?fm=' + format;

    if (containerType === HEADER) {
        return {
            srcSet: `${imageUrl}&w=1920 1920w, ${imageUrl}&w=768 768w, ${imageUrl}&w=425 425w`,
            sizes: '100vw'
        };
    }

    let imageSizes;

    if (isGrid) {
        switch (imageCount) {
            case 2:
                imageSizes = {
                    srcSet: `${imageUrl}&w=1200 1200w, ${imageUrl}&w=605 605w, ${imageUrl}&w=363 363w, ${imageUrl}&w=209 209w`,
                    sizes: '(max-width: 425px) 209px, (max-width: 768px) 363px, 605px'
                };
                break;
            case 4:
            case 8:
                imageSizes = {
                    srcSet: `${imageUrl}&w=905 905w, ${imageUrl}&w=605 605w, ${imageUrl}&w=305 305w, ${imageUrl}&w=363 363w, ${imageUrl}&w=209 209w`,
                    sizes: '(max-width: 425px) 209px, (max-width: 768px) 363px, 305px'
                };
                break;
            default:
                imageSizes = {
                    srcSet: `${imageUrl}&w=600 600w, ${imageUrl}&w=400 400w, ${imageUrl}&w=200 200w, ${imageUrl}&w=363 363w, ${imageUrl}&w=209 209w`,
                    sizes: '(max-width: 425px) 209px, (max-width: 768px) 363px, 200px'
                };
                break;
        }
    } else {
        switch (imageCount) {
            case 1:
                imageSizes = {
                    srcSet: `${imageUrl}&w=1230 1230w, ${imageUrl}&w=768 768w, ${imageUrl}&w=425 425w`,
                    sizes: '(max-width: 425px) 425px, (max-width: 768px) 768px, 1230px'
                };
                break;
            case 2:
                imageSizes = {
                    srcSet: `${imageUrl}&w=605 605w, ${imageUrl}&w=397 397w, ${imageUrl}&w=425 425w`,
                    sizes: '(max-width: 425px) 425px, (max-width: 768px) 397px, 605px'
                };
                break;
            case 3:
                imageSizes = {
                    srcSet: `${imageUrl}&w=605 605w, ${imageUrl}&w=397 397w, ${imageUrl}&w=425 425w`,
                    sizes: '(max-width: 425px) 425px, (max-width: 768px) 397px, 605px'
                };
                break;
            default:
                imageSizes = {
                    srcSet: `${imageUrl}&w=1250 1250w, ${imageUrl}&w=768 768w, ${imageUrl}&w=425 425w`,
                    sizes: '(max-width: 425px) 425px, (max-width: 768px) 768px, 1250px'
                };
                break;
        }
    }

    return imageSizes;
};

export const getWebpImage = (imageCount, image, containerType, isGrid) => {
    if (!image) {
        return {};
    }

    const imageSizes = getImageSizes(
        imageCount,
        image,
        containerType,
        isGrid,
        'webp'
    );

    const { srcSet, sizes } = imageSizes;

    return <source srcSet={srcSet} sizes={sizes} type="image/webp" />;
};
